export class OrganizationUserAcceptRequest {
    token: string;
}
